import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

//Categories
export const categoryManagementApi = async (page = 1, limit = 10, search = '') => {
    try {
        const params = { page };
        if (limit !== undefined && limit !== 10) {
            params.limit = limit;
        }
        if (search) params.search = search;
        const response = await axios.get(`${apiUrlOne}/categories/admin`, {
            params
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const categoryActiveApi = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/categories/admin`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCategoryById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/categories/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateCategory = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/categories/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/categories/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const postCategory = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/categories`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

//sub Categories

export const subCategoryManagementApi = async (categoryId, page = 1, limit = 10, search = '') => {
    try {
        const params = { page };
        if (limit !== undefined && limit !== 10) {
            params.limit = limit;
        }
        if (search) params.search = search;
        const response = await axios.get(`${apiUrlOne}/sub-categories/admin/${categoryId}`, {
            params
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const subCategoryActiveApi = async (categoryId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/sub-categories/admin/${categoryId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const subCategoryActiveApiWithoutPagination = async (categoryId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/sub-categories/admin-without-pagination/${categoryId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const postSubCategory = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/sub-categories`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateSubCategory = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/sub-categories/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteSubCategory = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/sub-categories/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getSubCategoryById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/sub-categories/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
